// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__1AXDX","requiredAsterisk":"Info_requiredAsterisk__3t_rq"};